import { Breadcrumbs, CrumbProps } from "@amzn/stencil-react-components/breadcrumbs";
import { Col, Container, Row } from "@amzn/stencil-react-components/layout";
import { MyAiToolsTable } from "common/components/MyAiToolsTable/MyAiToolsTable";
import { PageMainContainer } from "common/components/PageMainContainer/PageMainContainer";
import { Paths } from "common/paths/paths";
import { getString } from "common/uistringlabels/uiStringUtils";
import { PERMISSIONS } from "config";
import { UserPermissions } from "lib/services";
import React, { FC } from "react";
import { useHistory } from "react-router-dom";

export const MyAiTools: FC = () => {
  const toggleMyAiTools = UserPermissions.current.hasPermission(PERMISSIONS.TOGGLE_MY_AI_TOOLS);
  const history = useHistory();

  if (!toggleMyAiTools) {
    history.push(Paths.aiforme.url);
    return null;
  }

  return (
    <PageMainContainer>
      <Container isFullWidth={false}>
        <Col gridGap="S200" width={"100%"}>
          <Row>
            <Breadcrumbs
              crumbs={[
                {
                  title: getString("logoText"),
                  url: Paths.home.url,
                },
                {
                  title: getString("aiForMe.title"),
                  url: Paths.aiforme.url,
                },
                {
                  title: getString("aiForMe.myContributions"),
                },
              ]}
              onCrumbClick={
                /* istanbul ignore next */
                (e, crumb: CrumbProps) => {
                  if (crumb.url) {
                    e.preventDefault();
                    history.push(crumb.url);
                  }
                }
              }
            />
          </Row>
          <Row padding="S300" gridGap="S400" width={"100%"}>
            <MyAiToolsTable />
          </Row>
        </Col>
      </Container>
    </PageMainContainer>
  );
};
